import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { UserLoginApi } from "../../services/login";


function SignIn() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

    const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const onSubmit = async (data) => {
    try {
      const formData = {
        email: data?.email,
        password: data?.password
      }
      const response = await UserLoginApi(formData);

      if (response.ok) {
        const responseData = await response.json();
        toast.success(responseData?.message || "Login successful!");

        
        localStorage.setItem("token", responseData.token);
        localStorage.setItem("role", 'admin');
        localStorage.setItem("userData", JSON.stringify(responseData?.user));
        setTimeout(() => {
          if (response.status === 200) {
            navigate("/user-list", { replace: true });
          }
        }, 3000);
      } else {
        const responseData = await response.json();
        toast.error(responseData?.error || "Login successful!");
        console.error("Failed to submit form");
      }
    } catch (error) {
      console.error(error, "Error submitting form:");
    }
  };

  return (
    <>
      <div className="col-lg-6 d-flex justify-content-center">
        <div className="w-100 p-3 p-md-5 card border-0 shadow-sm">
          <form
            className="row g-1 p-3 p-md-4 mt-5"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="col-12 text-center mb-0">
              <h1>Log in</h1>
              <span>Free access to our dashboard.</span>
            </div>
            <div className="col-12">
              <div className="mb-2">
                <label className="form-label">Email address</label>
                <input
                  type="text"
                  id="email"
                  className="form-control form-control-lg"
                  placeholder="Email address"
                  {...register("email", {
                    pattern: {
                      value:
                        /^(?!.*\.{2})(?!\.)[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?<!\.)$/,
                      message: "Email is invalid",
                    },
                    required: "Email address is required",
                  })}
                />
                {errors.email?.type === "required" && (
                  <p role="alert" className="text-danger">
                    {errors.email.message}
                  </p>
                )}
                {errors.email?.type === "pattern" && (
                  <span className="text-danger">Email is invalid</span>
                )}
              </div>
            </div>
            <div className="col-12">
              <div className="mb-2">
                <div className="form-label">
                  <span className="d-flex justify-content-between align-items-center">
                    Password
                  </span>
                </div>
                <div className="position-relative passwordShow">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control form-control-lg lift"
                    placeholder="***************"
                    {...register("password", { required: true })}
                  />
                  {showPassword ? (
                    <FaEye onClick={togglePasswordVisibility} />
                  ) : (
                    <FaEyeSlash onClick={togglePasswordVisibility} />
                  )}
                </div>
                {errors.password && (
                  <span className="text-danger">This field is required</span>
                )}{" "}
              </div>
            </div>
            <div className="col-12 text-center mt-4 mb-2">
              <Button
                type="submit"
                className="btn btn-lg btn-block btn-light lift text-uppercase w-100 p-3"
              >
                LOG IN
              </Button>
            </div>
          </form>
        </div>
      </div>

    </>
  );
}

export default SignIn;
